import React from "react";
import "./index.css";

export default function Footer() {
  return (
  <footer className="footer">
      <div className="footer-copyright">
        <div className="top">
          <span>Designed by </span>
        </div>
        <div className="bottom">
          <span> Karan Tondare 🤟🏼</span> <span>2021</span>
        </div>
      </div>
      <div className="footer-links">
        <a
          href="mailto:surajkumaryadavvvv@gmail.com"
          title="email"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="text">email</span>
        </a>
        <a
          href="https://github.com/Officialthesky"
          title="github"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="text">github</span>
        </a>
        <a
          href="https://www.linkedin.com/in/surajthesky/"
          title="linkedin"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="text">linkedin</span>
        </a>
        <a
          href="https://twitter.com/Surajthesky"
          title="twitter"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="text">twitter</span>
        </a>
      </div>
    </footer>
  );
}